<div class="pin-modal">
  <h2 [style]="'fontSize.36' | translate">
    {{ 'parental_pin_header' | translate }}
  </h2>
  <p
    [innerHTML]="'parental_pin_desc' | translate"
    [style]="'fontSize.24' | translate"
  ></p>

  <div class="pin-boxes">
    <div class="pin-box">
      <input
        [style]="'fontSize.48' | translate"
        id="pin0"
        maxlength="1"
        [value]="pin[0] ? '*' : ''"
        readonly
      />
    </div>
    <div class="pin-box">
      <input
        [style]="'fontSize.48' | translate"
        id="pin1"
        maxlength="1"
        [value]="pin[1] ? '*' : ''"
        readonly
      />
    </div>
    <div class="pin-box">
      <input
        [style]="'fontSize.48' | translate"
        id="pin2"
        maxlength="1"
        [value]="pin[2] ? '*' : ''"
        readonly
      />
    </div>
    <div class="pin-box">
      <input
        [style]="'fontSize.48' | translate"
        id="pin3"
        maxlength="1"
        [value]="pin[3] ? '*' : ''"
        readonly
      />
    </div>
  </div>

  <div
    class="actions horizontal-as horizontal-focusable-container generic-dialog"
    data-left="numeric-keypad"
  >
    <app-icon-button
      [label]="'parental_pin_submit' | translate"
      (clicked)="submitPin()"
      class="submit-button"
      (keydown)="restrictFocus($event)"
    ></app-icon-button>
    <app-icon-button
      [label]="'global.cancel' | translate"
      (clicked)="clearPin()"
      class="cancel-button"
      (keydown)="restrictFocus($event)"
    ></app-icon-button>
  </div>
  <div
    class="error"
    [class.show]="errorMessage"
    [style]="'fontSize.24' | translate"
  >
    {{ errorMessage | translate }}
  </div>
</div>
